import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";

@Entity('parameter_master')
export class ParameterEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "id",
    })
    id: number;
    
    @Column("varchar", {
        nullable: false,
        length: 255,
        name: "buyer",
    })
    buyer: string;

    @Column("varchar", {
        nullable: false,
        length: 255,
        name: "parameter",
    })
    parameter: string;

    @CreateDateColumn({
        name: "created_at",
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user",
    })
    createdUser: string | null;
}
